<ng-container *transloco="let t;">
    <div class="templateFiltersContainer d-flex justify-content-start columngap align-items-center d-flex flex-wrap">
        <div class="form-group mb-0 d-flex justify-content-start align-items-center docStatusfilter">
            <label class="font-small-3 font-weight-500 mb-0 me-25">{{ t('Document types - dropdown - title (template listing) - Document types') }} </label>
            <ng-select [items]="documentTypes | documentTypeSelectorFor: 'document'" bindLabel="document_type" bindValue="id" [(ngModel)]="selectedDocumentType" [readonly]="readonly" [searchable]="false" [placeholder]="t('Filter placeholder (Template filters) - All')" [clearable]="false" (change)="onFilterChange()">
                <ng-template ng-option-tmp let-item="item">
                    <span class="ng-value-label">
                        @if (item.value === 'all'){
                            {{t('Filter placeholder (Template filters) - All')}}
                        }@else{
                            {{ item.document_type }}
                        }
                    </span>
                </ng-template>
            </ng-select>
        </div>        
        <div class="form-group mb-0 d-flex justify-content-start align-items-center docStatusfilter">
            <label class="font-small-3 font-weight-500 mb-0 me-25">{{ t('Languages - dropdown - title (template listing) - Languages') }} </label>
            <ng-select [(ngModel)]="selectedLanguage" [items]="languages" bindLabel="name" bindValue="value" [clearable]="false" (change)="onFilterChange()">
                <ng-template ng-label-tmp  ng-option-tmp let-item="item">
                    <span class="ng-value-label">
                        @if (!item.id){
                          {{t('Document - listview - filters - All')}}
                        }@else{
                            {{  t('language navbar list (navbar) - ' + item.name )}}
                        }
                    </span>
                </ng-template>
            </ng-select>
        </div>
        @if(templateType !== templateTypeEnum.EFORM){
            <div class="form-group mb-0 d-flex justify-content-start align-items-center docStatusfilter">
                <label class="font-small-3 font-weight-500 mb-0 me-25"> Template type </label>
                <ng-select [(ngModel)]="selectedTemplateType" [items]="templateTypes" bindLabel="name" bindValue="value" [clearable]="false" (change)="onFilterChange()">
                    <ng-template ng-label-tmp  ng-option-tmp let-item="item">
                        <span class="ng-value-label">
                            @if (!item.id){
                            {{t('Document - listview - filters - All')}}
                            }@else{
                                {{  item.name }}
                            }
                        </span>
                    </ng-template>
                </ng-select>
            </div>
        }
        <div class="form-group mb-0 d-flex justify-content-start align-items-center docStatusfilter">
            <label class="font-small-3 font-weight-500 mb-0 me-25"> {{t("Status (general) - Status")}} </label>
            <ng-select [(ngModel)]="selectedStatus" [items]="templateStatus" bindLabel="name" bindValue="value" [clearable]="false" (change)="onFilterChange()">
                <ng-template ng-label-tmp  ng-option-tmp let-item="item">
                    <span class="ng-value-label">
                        @if (!item.id){
                            {{t('Document - listview - filters - All')}}
                        }@else{
                            {{  item.name }}
                        }
                    </span>
                </ng-template>
            </ng-select>
        </div>
    </div>
</ng-container>
